import script from "./FeedManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedManagement.vue?vue&type=script&setup=true&lang=js"

import "./FeedManagement.vue?vue&type=style&index=0&id=1b5ed1a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b5ed1a4"]])

export default __exports__